import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { transformErrorResponse } from 'helpers/errors';
import deviceContractPage from 'decorators/deviceContractPage';
import DeviceContractInfo from '../components/DeviceContractInfo/DeviceContractInfo';
import DeviceContractSettledForm from '../components/DeviceContractSettledForm';
import { settleDeviceContract } from 'actions/deviceContracts';

export class ViewDeviceContract extends Component {
  state = {
    errors: null,
    successMsg: '',
  };

  settleDeviceContract = (values) => {
    const { settleDeviceContract, deviceContractId } = this.props;

    settleDeviceContract(deviceContractId, {
      settled: values.settled,
      settled_note: values.settled_note || null,
    })
      .then((res) => {
        this.setState({ successMsg: 'Successfully updated', errors: null });
      })
      .catch((err) => {
        this.setState({
          errors: transformErrorResponse(err.errors),
          successMsg: '',
        });
      });
  };

  render() {
    const { deviceContract, purchase, sub, attSub } = this.props;
    const { errors, successMsg } = this.state;
    if (!deviceContract) {
      return <div>Loading...</div>;
    }

    return (
      <div>
        <DeviceContractInfo
          deviceContract={deviceContract}
          purchase={purchase}
          sub={sub}
          attSub={attSub}
        />
        <DeviceContractSettledForm
          initialValues={{
            settled: deviceContract.settled,
            settled_note: deviceContract.settled_note,
          }}
          onSubmit={this.settleDeviceContract}
          errors={errors}
          successMsg={successMsg}
        />
      </div>
    );
  }
}

const mapDispatchToProps = {
  settleDeviceContract,
};

export const ConnectedViewDeviceContract = connect(
  null,
  mapDispatchToProps,
)(ViewDeviceContract);

export default compose(deviceContractPage)(ConnectedViewDeviceContract);
